import { ContactAddress } from './contact-address.model';
import { ContactEmail } from './contact-email.model';
import { ContactPhone } from './contact-phone.model';

export class Contact {
    ContactId: number;
    Prefix: string;
    FirstName: string;
    MiddleName: string;
    LastName: string;
    Suffix: string;
    ContactStatus: string;
    FullName: string;
    CreateDate: Date;
    ModifyDate: Date;

    primaryAddress: ContactAddress;
    primaryEmail: ContactEmail;
    primaryPhone: ContactPhone;

    ContactAddresses = new Array<ContactAddress>();
    ContactEmails = new Array<ContactEmail>();
    ContactPhoneNumbers = new Array<ContactPhone>();

    constructor(contact?: Contact) {
        if (contact) {

            this.ContactId = contact.ContactId;
            this.Prefix = contact.Prefix;
            this.FirstName = contact.FirstName;
            this.MiddleName = contact.MiddleName;
            this.LastName = contact.LastName;
            this.Suffix = contact.Suffix;
            this.ContactStatus = contact.ContactStatus;

            this.ContactAddresses = contact.ContactAddresses || new Array<ContactAddress>();
            this.ContactEmails = contact.ContactEmails || new Array<ContactEmail>();
            this.ContactPhoneNumbers = contact.ContactPhoneNumbers || new Array<ContactPhone>();
        }

        Contact.normalize(this);
    }
    
    static normalize(contact: Contact) {
        contact.Prefix = Contact.safeString(contact.Prefix);
        contact.FirstName = Contact.safeString(contact.FirstName);
        contact.MiddleName = Contact.safeString(contact.MiddleName);
        contact.LastName = Contact.safeString(contact.LastName);
        contact.Suffix = Contact.safeString(contact.Suffix);

        contact.FullName = `${Contact.safeString(contact.Prefix)} ${Contact.safeString(contact.FirstName)} ${Contact.safeString(contact.MiddleName)} ${Contact.safeString(contact.LastName)} ${Contact.safeString(contact.Suffix)}`.replace(/\s\s+/g, " ").trim();
        Contact.setPrimaryAddress(contact);
        Contact.setPrimaryEmail(contact);
        Contact.setPrimaryPhone(contact);
        //if (new Date(contact.ModifyDate).getFullYear() < 2000) {
        //    contact.ModifyDate = contact.CreateDate;
        //}
    }

    static safeString(value: string) {
        if (!value) {
            return '';
        }

        return value.trim();
    }

    private static setPrimaryAddress(contact: Contact) {
        contact.ContactAddresses = contact.ContactAddresses || new Array<ContactAddress>();
        var primaryAddresses = contact.ContactAddresses.filter((c) => {
            return c.IsPrimary;
        });

        if (primaryAddresses.length > 0) {
            contact.primaryAddress = primaryAddresses[0];
        }
        else if (contact.ContactAddresses.length > 0) {
            contact.primaryAddress = contact.ContactAddresses[0];
        }
        else {
            contact.primaryAddress = new ContactAddress();
            contact.primaryAddress.IsPrimary = true;
            contact.primaryAddress.AddressType = 1;
        }
    }

    private static setPrimaryEmail(contact: Contact) {
        contact.ContactEmails = contact.ContactEmails || new Array<ContactEmail>();
        if (contact.ContactEmails.length > 0) {
            contact.primaryEmail = contact.ContactEmails[0];
        }
        else {
            contact.primaryEmail = new ContactEmail();
            contact.primaryEmail.IsPrimary = true;
        }
    }

    private static setPrimaryPhone(contact: Contact) {
        contact.ContactPhoneNumbers = contact.ContactPhoneNumbers || new Array<ContactPhone>();
        var primaryPhones = contact.ContactPhoneNumbers.filter((p) => {
            return p.IsPrimary;
        });

        if (primaryPhones.length > 0) {
            contact.primaryPhone = primaryPhones[0];
        }
        else if (contact.ContactPhoneNumbers.length > 0) {
            contact.primaryPhone = contact.ContactPhoneNumbers[0];
        }
        else {
            contact.primaryPhone = new ContactPhone();
            contact.primaryPhone.IsPrimary = true;
            contact.primaryPhone.PhoneType = 1;
        }
    }

    static readyForSave(contact: Contact) {
        Contact.normalizePrimaryAddresss(contact);
        Contact.normalizePrimaryEmail(contact);
        Contact.normalizePrimaryPhone(contact);
    }

    private static normalizePrimaryEmail(contact: Contact)
    {
        //if (!Contact.isEmpty(contact.primaryEmail.emailAddress)) {
        //    var emailIndex = contact.contactEmails.indexOf(contact.primaryEmail);
        //    if (emailIndex > -1) {
        //        contact.contactEmails.splice(emailIndex, 1);
        //    }
        //}
        //else {
            var editedEmail = contact.ContactEmails.filter((email) => {
                return email.ContactEmailId == contact.primaryEmail.ContactEmailId;
            })[0];

            var emailIndex = contact.ContactEmails.indexOf(editedEmail);
            contact.ContactEmails.splice(emailIndex, 1, contact.primaryEmail);
        //}
    }

    private static normalizePrimaryAddresss(contact: Contact) {
        //if (Contact.isEmpty(contact.primaryAddress.address1 + contact.primaryAddress.address2 + contact.primaryAddress.city + contact.primaryAddress.state + contact.primaryAddress.zip)) {
        //    var addressIndex = contact.contactAddresses.indexOf(contact.primaryAddress);
        //    if (addressIndex > -1) {
        //        contact.contactAddresses.splice(addressIndex, 1);
        //    }
        //}
        //else {
            var editedAddress = contact.ContactAddresses.filter((address) => {
                return address.ContactAddressId == contact.primaryAddress.ContactAddressId;
            })[0];

            var addressIndex = contact.ContactAddresses.indexOf(editedAddress);

            contact.ContactAddresses.splice(addressIndex, 1, contact.primaryAddress);
        //}
    }

    private static normalizePrimaryPhone(contact: Contact) {
        //if (Contact.isEmpty(contact.primaryPhone.phoneNumber)) {
        //    var phoneIndex = contact.contactPhoneNumbers.indexOf(contact.primaryPhone);
        //    if (phoneIndex > -1) {
        //        contact.contactPhoneNumbers.splice(phoneIndex, 1);
        //    }
        //}
        //else {
            var editedPhone = contact.ContactPhoneNumbers.filter((phone) => {
                return phone.ContactPhoneId == contact.primaryPhone.ContactPhoneId;
            })[0];

            var phoneIndex = contact.ContactPhoneNumbers.indexOf(editedPhone);

            contact.ContactPhoneNumbers.splice(phoneIndex, 1, contact.primaryPhone);
        //}
    }

    private static isEmpty(string: String) {
        return !string || string.trim().length == 0;
    }
}   


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/model/crm/contact.model.ts